import AContainer from '../../library/ExtendedObjects/AContainer.js';

export default class Preloader_StarField extends AContainer
{
    constructor(scene)
    {
        super(scene);

        for(let i = 0; i < 120; i++)
        {
            let star = this.scene.addCirc(0, 0, Math.random() * .4 * 10, 0x1c4a51);
            this.add(star);
            star.alpha = 0;
            star.tint = 0x24876b;
            this.scene.addDelay(Math.random() * 5000, ()=>{this.fadeIn(star);});
        }
    }

    fadeIn(star)
    {
        star.x = Math.random() * this.scene.game.config.width;
        star.y = Math.random() * this.scene.game.config.height;

        this.scene.addTween(star, 200, {alpha: 1}, Phaser.Math.Easing.Circular);

        this.scene.addDelay(2000, ()=>{this.fadeOut(star);});
    }

    fadeOut(star)
    {
        this.scene.addTween(star, 300, {alpha: 0}, Phaser.Math.Easing.Circular, ()=>{this.fadeIn(star);});
    }
}